import React, { Component } from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import AsResponsiveContent from '../airship-wrappers/AsResponsiveContent';
import DpsCategoryWidget from '../DpsCategoryWidget';
import DpsLayerToggle from '../DpsLayerToggle';
import DpsLegendColorContinuousPolygon from '../DpsLegendColorContinuousPolygon'
import DpsLegendCategory from '../DpsLegendCategory';
import DpsActiveFilters from '../DpsActiveFilters';
import * as layers from '../../layers';
import DpsLegendSizeContinuousPoint from '../DpsLegendSizeContinuousPoint';
import { MAP_CONFIG } from '../../MAP_CONFIG';
import AsSwitch from '../airship-wrappers/AsSwitch';
import { withCarto } from '../../carto/withCarto';
import DpsLoadingIndicator from '../DpsLoadingIndicator';
import DpsQueryModifier from '../DpsQueryModifier';

export class Property extends Component {
  selectedParcelsLayers = [
    "damageParcels",
    "damageParcelsUdf100cont",
    "damageParcelsUdf100cost",
    "damageParcelsUdf500cont",
    "damageParcelsUdf500cost",
    "damageParcelsUdflevee_cost",
    "damageParcelsUdflevee_cont",
    "damageParcelsUdfcoast_cost",
    "damageParcelsUdfcoast_cont",
    "damageParcelsEQ1",
    "damageParcelsEQ2",
  ]
  selectedAssetsLayers = [
    "damageAssets",
    "damageAssetsI100conten",
    "damageAssetsI100costlo",
    "damageAssetsI500conten",
    "damageAssetsI500costlo",
    "damageAssetsEQ1",
    "damageAssetsEQ2",
  ]
  selectedLayers = [...this.selectedParcelsLayers, ...this.selectedAssetsLayers]

  constructor(props) {
    super(props);
    this.categoryWidget = React.createRef()
    this.categoryWidgetAssets = React.createRef()
    this.state = {
      ready: false,
      includeParcels: true,
      includeAssets: true,
      damageParcelsUdf100cont: undefined,
      damageParcelsUdf100cost: undefined,
      damageParcelsUdf500cont: undefined,
      damageParcelsUdf500cost: undefined,
      damageParcelsUdflevee_cost: undefined,
      damageParcelsUdflevee_cont: undefined,
      damageParcelsUdfcoast_cost: undefined,
      damageParcelsUdfcoast_cont: undefined,
      damageParcelsEQ1: undefined,
      damageParcelsEQ2: undefined,
      damageAssetsI100conten: undefined,
      damageAssetsI100costlo: undefined,
      damageAssetsI500conten: undefined,
      damageAssetsI500costlo: undefined,
      damageAssetsEQ1: undefined,
      damageAssetsEQ2: undefined,
      isLoadingParcels: true,
      isLoadingAssets: true,
    }
  }

  componentDidMount() {
    this.props.CartoContext.initCarto()
  }

  componentWillUnmount() {
    if (this.state.ready) {
      this.props.CartoContext.resetLayers()
      this.props.CartoContext.dataviews['damageAssetsEQ1'].off('dataChanged', this.updateDamageAssetsEQ1)
      this.props.CartoContext.dataviews['damageAssetsEQ2'].off('dataChanged', this.updateDamageAssetsEQ2)
      this.props.CartoContext.dataviews['damageAssetsI100costlo'].off('dataChanged', this.updateDamageAssetsI100costlo)
      this.props.CartoContext.dataviews['damageAssetsI100conten'].off('dataChanged', this.updateDamageAssetsI100conten)
      this.props.CartoContext.dataviews['damageAssetsI500costlo'].off('dataChanged', this.updateDamageAssetsI500costlo)
      this.props.CartoContext.dataviews['damageAssetsI500conten'].off('dataChanged', this.updateDamageAssetsI500conten)
      this.props.CartoContext.dataviews['damageParcelsEQ1'].off('dataChanged', this.updateDamageParcelsEQ1)
      this.props.CartoContext.dataviews['damageParcelsEQ2'].off('dataChanged', this.updateDamageParcelsEQ2)
      this.props.CartoContext.dataviews['damageParcelsUdf100cost'].off('dataChanged', this.updateDamageParcelsUdf100cost)
      this.props.CartoContext.dataviews['damageParcelsUdf100cont'].off('dataChanged', this.updateDamageParcelsUdf100cont)
      this.props.CartoContext.dataviews['damageParcelsUdf500cost'].off('dataChanged', this.updateDamageParcelsUdf500cost)
      this.props.CartoContext.dataviews['damageParcelsUdf500cont'].off('dataChanged', this.updateDamageParcelsUdf500cont)
      this.props.CartoContext.dataviews['damageParcelsUdflevee_cost'].off('dataChanged', this.updateDamageParcelsUdflevee_cost)
      this.props.CartoContext.dataviews['damageParcelsUdflevee_cont'].off('dataChanged', this.updateDamageParcelsUdflevee_cont)
      this.props.CartoContext.dataviews['damageParcelsUdfcoast_cost'].off('dataChanged', this.updateDamageParcelsUdfcoast_cost)
      this.props.CartoContext.dataviews['damageParcelsUdfcoast_cont'].off('dataChanged', this.updateDamageParcelsUdfcoast_cont)
    }
  }

  onReady = () => {
    this.props.CartoContext.loadMap(MAP_CONFIG)
    this.props.CartoContext.loadLayers([
      { ...layers.eq1, hide: true },
      { ...layers.eq2, hide: true },
      { ...layers.flood, hide: true },
      {...layers.damageParcels, order: 3, callback: this.updateParcelsStatus},
      {...layers.damageAssets, order: 4, callback: this.updateAssetsStatus},
      layers.municipality,
      layers.kernCounty,
    ])
    this.props.CartoContext.loadDataview(layers.damageParcelsCategories)
    this.props.CartoContext.loadDataview(layers.damageAssetsCategories)

    this.props.CartoContext.loadDataview(layers.damageAssetsEQ1)
    this.props.CartoContext.loadDataview(layers.damageAssetsEQ2)
    this.props.CartoContext.loadDataview(layers.damageAssetsI100costlo)
    this.props.CartoContext.loadDataview(layers.damageAssetsI100conten)
    this.props.CartoContext.loadDataview(layers.damageAssetsI500costlo)
    this.props.CartoContext.loadDataview(layers.damageAssetsI500conten)

    this.props.CartoContext.dataviews['damageAssetsEQ1'].on('dataChanged', this.updateDamageAssetsEQ1)
    this.props.CartoContext.dataviews['damageAssetsEQ2'].on('dataChanged', this.updateDamageAssetsEQ2)
    this.props.CartoContext.dataviews['damageAssetsI100costlo'].on('dataChanged', this.updateDamageAssetsI100costlo)
    this.props.CartoContext.dataviews['damageAssetsI100conten'].on('dataChanged', this.updateDamageAssetsI100conten)
    this.props.CartoContext.dataviews['damageAssetsI500costlo'].on('dataChanged', this.updateDamageAssetsI500costlo)
    this.props.CartoContext.dataviews['damageAssetsI500conten'].on('dataChanged', this.updateDamageAssetsI500conten)

    this.props.CartoContext.loadDataview(layers.damageParcelsEQ1)
    this.props.CartoContext.loadDataview(layers.damageParcelsEQ2)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdf100cost)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdf100cont)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdf500cost)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdf500cont)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdflevee_cost)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdflevee_cont)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdfcoast_cost)
    this.props.CartoContext.loadDataview(layers.damageParcelsUdfcoast_cont)

    this.props.CartoContext.dataviews['damageParcelsEQ1'].on('dataChanged', this.updateDamageParcelsEQ1)
    this.props.CartoContext.dataviews['damageParcelsEQ2'].on('dataChanged', this.updateDamageParcelsEQ2)
    this.props.CartoContext.dataviews['damageParcelsUdf100cost'].on('dataChanged', this.updateDamageParcelsUdf100cost)
    this.props.CartoContext.dataviews['damageParcelsUdf100cont'].on('dataChanged', this.updateDamageParcelsUdf100cont)
    this.props.CartoContext.dataviews['damageParcelsUdf500cost'].on('dataChanged', this.updateDamageParcelsUdf500cost)
    this.props.CartoContext.dataviews['damageParcelsUdf500cont'].on('dataChanged', this.updateDamageParcelsUdf500cont)
    this.props.CartoContext.dataviews['damageParcelsUdflevee_cost'].on('dataChanged', this.updateDamageParcelsUdflevee_cost)
    this.props.CartoContext.dataviews['damageParcelsUdflevee_cont'].on('dataChanged', this.updateDamageParcelsUdflevee_cont)
    this.props.CartoContext.dataviews['damageParcelsUdfcoast_cost'].on('dataChanged', this.updateDamageParcelsUdfcoast_cost)
    this.props.CartoContext.dataviews['damageParcelsUdfcoast_cont'].on('dataChanged', this.updateDamageParcelsUdfcoast_cont)

    this.props.CartoContext.addToMap()
    this.props.CartoContext.addPopup('damageParcels', 'featureClicked', this.popupContentParcels)
    this.props.CartoContext.addPopup('damageAssets', 'featureClicked', this.popupContentAssets)
    this.setState(state => ({ ...state, ready: true }))
  }

  updateParcelsStatus = (loaded) => {
    this.setState(state => ({
      ...state,
      isLoadingParcels: loaded !== 'loaded'
    }))
  }

  updateAssetsStatus = (loaded) => {
    this.setState(state => ({
      ...state,
      isLoadingAssets: loaded !== 'loaded'
    }))
  }

  popupContentAssets = (vars) => (`
    <div style="max-width: 200px; max-height: 200px; overflow: scroll;">${
    [
      {
        label: 'Category',
        value: vars.lyr_sub,
      },
      {
        label: 'Sub Category',
        value: vars.lyr_subwp,
      },
      {
        label: 'Insured Replacement Value',
        value: '$' + numeral(vars.cost * 1000).format('0,0'),
      },
      {
        label: '100YR FEMA Building Damage',
        value: '$' + numeral(vars.i100cost * 1000).format('0,0'),
      },
      {
        label: '100YR FEMA Contents Damage',
        value: '$' + numeral(vars.i100cont * 1000).format('0,0'),
      },
      {
        label: '500YR FEMA Building Damage',
        value: '$' + numeral(vars.i500cost * 1000).format('0,0'),
      },
      {
        label: '500YR FEMA Contents Damage',
        value: '$' + numeral(vars.i500cont * 1000).format('0,0'),
      },
      {
        label: 'M6.8 Concord Green Valley',
        value: '$' + numeral(vars.ieq1econ * 1000).format('0,0'),
      },
      {
        label: 'M7.1 Hayward Rodgers Creek',
        value: '$' + numeral(vars.ieq2econ * 1000).format('0,0'),
      },
      {
        label: 'Geographic Location',
        value: vars.mun,
      },
    ].map(field => (
      `<small style="opacity: 0.67;">${field.label}</small>
            <p style="margin-top: 0px;" class="description open-sans">${field.value}</p>`
    )).join('')
    }</div>
  `)

  popupContentParcels = (vars) => (`
    <div style="max-width: 200px; max-height: 200px; overflow: scroll;">${
    [
      {
        label: 'Municipality',
        value: vars.mun,
      },
      {
        label: 'Building Value',
        value: '$' + numeral(vars.cost * 1000).format(0, 0),
      },
      {
        label: 'Content Value',
        value: '$' + numeral(vars.contentcos * 1000).format(0, 0),
      },
      {
        label: '100YR Flood Building Damage',
        value: '$' + numeral(vars.p100cost * 1000).format('0,0'),
      },
      {
        label: '100YR Flood Content Damage',
        value: '$' + numeral(vars.p100cont * 1000).format('0,0'),
      },
      {
        label: '500YR Flood Building Damage',
        value: '$' + numeral(vars.p500cost * 1000).format('0,0'),
      },
      {
        label: '500YR Flood Content Damage',
        value: '$' + numeral(vars.p500cont * 1000).format('0,0'),
      },
      {
        label: 'Levee Flood building Damage',
        value: '$' + numeral(vars.levcost * 1000).format('0,0'),
      },
      {
        label: 'Levee Flood Content Damage',
        value: '$' + numeral(vars.levcont * 1000).format('0,0'),
      },
      {
        label: 'Coastal Flood building Damage',
        value: '$' + numeral(vars.coastcost * 1000).format('0,0'),
      },
      {
        label: 'Coastal Flood Content Damage',
        value: '$' + numeral(vars.coastcont * 1000).format('0,0'),
      },
      {
        label: 'M6.8 Concord Green Valley',
        value: '$' + numeral(vars.peq1econ * 1000).format('0,0'),
      },
      {
        label: 'M7.1 Hayward Rodgers Creek',
        value: '$' + numeral(vars.peq2econ * 1000).format('0,0'),
      },
    ].map(field => (
      `<small style="opacity: 0.67;">${field.label}</small>
            <p style="margin-top: 0px;" class="description open-sans">${field.value}</p>`
    )).join('')
    }</div>
  `)

  updateDamageParcelsEQ1 = (data) => {
    this.setState({
      damageParcelsEQ1: data.result * 1000
    })
  }

  updateDamageParcelsEQ2 = (data) => {
    this.setState({
      damageParcelsEQ2: data.result * 1000
    })
  }

  updateDamageAssetsEQ1 = (data) => {
    this.setState({
      damageAssetsEQ1: data.result * 1000
    })
  }

  updateDamageAssetsEQ2 = (data) => {
    this.setState({
      damageAssetsEQ2: data.result * 1000
    })
  }

  updateDamageAssetsI100costlo = (data) => {
    this.setState({
      damageAssetsI100costlo: data.result * 1000
    })
  }

  updateDamageAssetsI100conten = (data) => {
    this.setState({
      damageAssetsI100conten: data.result * 1000
    })
  }

  updateDamageAssetsI500costlo = (data) => {
    this.setState({
      damageAssetsI500costlo: data.result * 1000
    })
  }

  updateDamageAssetsI500conten = (data) => {
    this.setState({
      damageAssetsI500conten: data.result * 1000
    })
  }

  updateDamageParcelsUdf100cost = (data) => {
    this.setState({
      damageParcelsUdf100cost: data.result * 1000
    })
  }

  updateDamageParcelsUdf100cont = (data) => {
    this.setState({
      damageParcelsUdf100cont: data.result * 1000
    })
  }

  updateDamageParcelsUdf500cost = (data) => {
    this.setState({
      damageParcelsUdf500cost: data.result * 1000
    })
  }

  updateDamageParcelsUdf500cont = (data) => {
    this.setState({
      damageParcelsUdf500cont: data.result * 1000
    })
  }

  updateDamageParcelsUdflevee_cost = (data) => {
    this.setState({
      damageParcelsUdflevee_cost: data.result * 1000
    })
  }

  updateDamageParcelsUdflevee_cont = (data) => {
    this.setState({
      damageParcelsUdflevee_cont: data.result * 1000
    })
  }

  updateDamageParcelsUdfcoast_cost = (data) => {
    this.setState({
      damageParcelsUdfcoast_cost: data.result * 1000
    })
  }

  updateDamageParcelsUdfcoast_cont = (data) => {
    this.setState({
      damageParcelsUdfcoast_cont: data.result * 1000
    })
  }
  clearFilters = () => {
    this.categoryWidget.current.clearSelection()
    this.categoryWidgetAssets.current.clearSelection()
    this.selectedLayers.forEach(layer => {
      this.props.CartoContext.clearFilters(layer)
    })
    this.setState({
      includeAssets: true,
      includeParcels: true,
    })
  }

  parcelsChanged = (event) => {
    this.setState({ includeParcels: event.detail })
  }

  assetsChanged = (event) => {
    this.setState({ includeAssets: event.detail })
  }

  render() {
    return (
      <AsResponsiveContent onReady={this.onReady}>
        <DpsLoadingIndicator isLoading={this.state.isLoadingAssets ||  this.state.isLoadingParcels}></DpsLoadingIndicator>
        <aside className="as-sidebar as-sidebar--left as-sidebar-damage" data-name="Jurisdiction">
          <div className="as-container as-p--16">
            {
              this.state.ready && <React.Fragment>
                <DpsCategoryWidget ref={this.categoryWidget} dataview={'damageParcelsCategories'} selectedLayers={this.selectedLayers} heading="Parcel Jurisdiction" field="mun" description="Select parcels in any jurisdiction (parcel counts shown)"></DpsCategoryWidget>
                <DpsCategoryWidget ref={this.categoryWidgetAssets} dataview={'damageAssetsCategories'} selectedLayers={this.selectedAssetsLayers} heading="Asset Jurisdiction" field="mun" description="Select assets in any jurisdiction"></DpsCategoryWidget>
              </React.Fragment>
            }
          </div>
        </aside>
        <main className="as-main">
          <div className="as-map-panels" data-name="Layers">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--right">
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 200 }}>
                <h4 className="as-subheader">Map Hazard Layers</h4>
                <DpsLayerToggle label="Parcel Cost" layer="damageParcels" checked>
                  <as-legend>
                    <DpsLegendSizeContinuousPoint layer="damageParcels"></DpsLegendSizeContinuousPoint>
                    <DpsLegendColorContinuousPolygon layer="damageParcels"></DpsLegendColorContinuousPolygon>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="Asset Cost" layer="damageAssets" checked>
                  <as-legend>
                    <DpsLegendSizeContinuousPoint layer="damageAssets"></DpsLegendSizeContinuousPoint>
                    <DpsLegendColorContinuousPolygon layer="damageAssets"></DpsLegendColorContinuousPolygon>
                  </as-legend>
                </DpsLayerToggle>
                <p>Hazard Layer</p>
                <DpsLayerToggle label="M6.8 Concord Green Valley" layer="eq1" beforeLayerID="damageParcels">
                  <as-legend description="M6.8 Concord Green Valley">
                    <DpsLegendCategory layer="eq1"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="M7.1 Hayward Rodgers Creek" layer="eq2" beforeLayerID="damageParcels">
                  <as-legend description="M7.1 Hayward Rodgers Creek">
                    <DpsLegendCategory layer="eq2"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <DpsLayerToggle label="FEMA Flood Hazard" layer="flood" beforeLayerID="damageParcels">
                  <as-legend>
                    <DpsLegendCategory layer="flood"></DpsLegendCategory>
                  </as-legend>
                </DpsLayerToggle>
                <p>Base Map</p>
                <DpsLayerToggle label="Mendocino County" layer="kernCounty" checked beforeLayerID="damageParcels">
                </DpsLayerToggle>
                <DpsLayerToggle label="Municipality" layer="municipality" checked beforeLayerID="damageParcels">
                </DpsLayerToggle>
              </div>
            </div>}
          </div>
          <div className="as-map-panels" data-name="Summary">
            {this.state.ready && <div className="as-panel as-panel--top as-panel--left">
              <div className="as-panel__element as-p--16 as-body summary" style={{ minWidth: 400 }}>
                <table>
                  <tbody>
                    <tr>
                      <th>
                        Flood
                      </th>
                      <th>
                        Content Loss
                      </th>
                      <th>
                        Structure Loss
                      </th>
                      <th>
                        Total
                      </th>
                    </tr>
                    <tr>
                      <td>
                        100-YR
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdf100cont : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI100conten : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdf100cost : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI100costlo : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdf100cont : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI100conten : 0) +
                            (this.state.includeParcels ? this.state.damageParcelsUdf100cost : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI100costlo : 0)
                          ).format(0, 0)
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>
                        500-YR
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdf500cont : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI500conten : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdf500cost : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI500costlo : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdf500cont : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI500conten : 0) +
                            (this.state.includeParcels ? this.state.damageParcelsUdf500cost : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsI500costlo : 0)
                          ).format(0, 0)
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Levee
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdflevee_cont : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdflevee_cost : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdflevee_cont : 0) +
                            (this.state.includeParcels ? this.state.damageParcelsUdflevee_cost : 0)
                          ).format(0, 0)
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Coastal Flooding
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdfcoast_cont : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdfcoast_cost : 0)
                          ).format(0, 0)
                        }
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsUdfcoast_cont : 0) +
                            (this.state.includeParcels ? this.state.damageParcelsUdfcoast_cost : 0)
                          ).format(0, 0)
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="as-panel__element as-p--16 as-body summary" style={{ minWidth: 300 }}>
                <table>
                  <tbody>
                    <tr>
                      <th>
                        Earthquake
                      </th>
                      <th>
                        Economic Loss
                      </th>
                    </tr>
                    <tr>
                      <td>
                        M6.8 Concord Green Valley
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsEQ1 : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsEQ1 : 0)
                          ).format(0, 0)
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>
                        M7.1 Hayward Rodgers Creek
                      </td>
                      <td>
                        ${
                          numeral(
                            (this.state.includeParcels ? this.state.damageParcelsEQ2 : 0) +
                            (this.state.includeAssets ? this.state.damageAssetsEQ2 : 0)
                          ).format(0, 0)
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="as-panel__element as-p--16 as-body" style={{ minWidth: 300 }}>
                <p style={{ marginTop: 0 }}>Damage Summary Table Filters</p>
                <AsSwitch style={{ display: 'block', marginTop: 8, marginBottom: 8 }} label="Parcels" onChanged={this.parcelsChanged} checked={this.state.includeParcels}></AsSwitch>
                <AsSwitch style={{ display: 'block', marginTop: 8, marginBottom: 8 }} label="Insured Assets" onChanged={this.assetsChanged} checked={this.state.includeAssets}></AsSwitch>
                <DpsQueryModifier label="Flood Damages" layerNames={this.selectedLayers} field="fldbln" values={[1]}></DpsQueryModifier>
                <DpsQueryModifier label="Earthquake Damages" layerNames={this.selectedLayers} field="eqbln" values={[1]}></DpsQueryModifier>
              </div>
              <div className="dps-mx-8">
                <DpsActiveFilters selectedLayers={[{ layerName: 'damageParcels', label: 'Selected Parcels' }, { layerName: 'damageAssets', label: 'Selected Assets' }]} minWidth={300}></DpsActiveFilters>
                <button className="as-panel__element as-btn as-btn--complementary" style={{ color: '#FFF', justifyContent: 'center', minWidth: 300, width: '100%' }} onClick={this.clearFilters}>Clear All Filters</button>
              </div>
            </div>
            }
          </div>
          <div className="as-map-area">
            <div id="map"></div>
          </div>
        </main>
      </AsResponsiveContent >
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(Property));
